import store from "./store";

import { toggleDemoMessageStatus } from "modules/userRedux/userAction";

export const toggleDemoMessage = () => store.dispatch(toggleDemoMessageStatus());
